export enum USER_ROLE {
    SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    ADMIN = 'ROLE_ADMIN',
    SECTION_MANAGER = 'ROLE_SECTION_MANAGER',
    SHIFT_MANAGER = 'ROLE_SHIFT_MANAGER',
    OPERATION_SHIFT_MANAGER = 'ROLE_OPERATION_SHIFT_MANAGER',
    OPERATION_EMPLOYEE = 'ROLE_OPERATION_EMPLOYEE',
    EMPLOYEE = 'ROLE_EMPLOYEE',
    REQUESTER = 'ROLE_REQUESTER',
    STS_EMPLOYEE = 'ROLE_STS_EMPLOYEE',
    ACCOUNT_MANAGER = 'ROLE_ACCOUNT_MANAGER',
    DIRECTOR = 'ROLE_DIRECTOR',
    GENERAL_MANAGER = 'ROLE_GENERAL_MANAGER',


}

export enum USER_ROLEـNAMES {
    ROLE_SUPER_ADMIN = '',
    ROLE_ADMIN = '',
    ROLE_SECTION_MANAGER = '',
    ROLE_SHIFT_MANAGER = '',
    ROLE_OPERATION_SHIFT_MANAGER = '',
    ROLE_OPERATION_EMPLOYEE = '',
    ROLE_EMPLOYEE = '',
    ROLE_REQUESTER = '',
    ROLE_STS_EMPLOYEE = '',
    ROLE_ACCOUNT_MANAGER = '',
    ROLE_MANAGER = '',
    ROLE_DIRECTOR = '',
    ROLE_GENERAL_MANAGER = '',

}
